import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'edit-template-basic-form',
  templateUrl: './edit-template-basic-form.component.html',
  styleUrl: './edit-template-basic-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditTemplateBasicFormComponent implements OnInit {
  @Input() Form1 = [];
  @Input() documentForm;
  @Input() askSecurityQuestion = false;
  @Output() moveToNextStep = new EventEmitter<void>();
  arrayItems;
  filterArrayItems = [];
  isEnableForm = false;
  beneFicaryForm = [];
  constructor(private cd: ChangeDetectorRef, private formBuilder: UntypedFormBuilder) {}
  // convenience getters for easy access to form fields
  get f() {
    return this.documentForm.controls;
  }
  get t() {
    return this.f.dynamicFieldsForm as UntypedFormArray;
  }

  templateList(empIndex: number, formControlName): UntypedFormArray {
    return this.documentForm.controls.beneFicaryForm['controls'][empIndex]['controls'][formControlName];
  }
  removeBeneficary(formcontrolName, index, childIndex) {
    const items = this.documentForm.controls['beneFicaryForm']['controls'][index]['controls'][formcontrolName] as UntypedFormArray;
    items.removeAt(childIndex);
    this.cd.detectChanges();
  }
  addBeneficiarybyform(formcontrolName, index) {
    const element = this.Form1[0]['multiFieldForm'][index];
    const test = new UntypedFormGroup({});
    element.template.forEach((childelement) => {
      if (childelement['type'] == 'email') {
        if (childelement['isRequired']) {
          test.addControl(childelement.formControlName, new UntypedFormControl('', [Validators.required, Validators.email]));
        } else {
          test.addControl(childelement.formControlName, new UntypedFormControl('', [Validators.email]));
        }
      } else {
        if (childelement['isRequired']) {
          test.addControl(childelement.formControlName, new UntypedFormControl('', Validators.required));
        } else {
          test.addControl(childelement.formControlName, new UntypedFormControl(''));
        }
      }
    });
    const items = this.documentForm.controls['beneFicaryForm']['controls'][index]['controls'][formcontrolName] as UntypedFormArray;
    items.push(test);
    this.cd.detectChanges();
  }

  toggleActive(event: any) {
    event.preventDefault();
    this.isEnableForm = !this.isEnableForm;
  }

  disableWhiteSpaceOnFirstCharacter(event) {
    if (event.target.selectionStart == 0 && (event.keyCode == 32 || event.keyCode == 9)) {
      event.preventDefault();
    }
  }

  ngOnInit(): void {
    let dynamicFieldsFormValue = this.documentForm.value.dynamicFieldsForm[0];

    let filterData = this.Form1[0].singleFieldForm.map((x) => {
      return {
        ...x,
        record_default: x?.record_default ? +x.record_default : -1,
      };
    });
    filterData = filterData.sort(function (a, b) {
      var keyA = a['record_default'],
        keyB = b['record_default'];
      // Compare the 2 dates
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });

    this.filterArrayItems = filterData.filter((x) => x.record_default > 0);

    this.documentForm.setControl('dynamicFieldsForm', new UntypedFormArray([]));
    this.arrayItems = this.Form1[0]['singleFieldForm'];
    this.t.clear();
    const test = this.formBuilder.group({});
    this.arrayItems.forEach(function (value) {
      if (value['type'] === 'Section') {
      } else if (value['type'] == 'email') {
        test.addControl(value.formControlName, new UntypedFormControl(''));
      } else {
        test.addControl(value.formControlName, new UntypedFormControl(''));
      }
    });
    this.documentForm.removeControl('beneFicaryForm');
    this.documentForm.addControl('beneFicaryForm', new UntypedFormArray([]));
    if (this.Form1[0]['multiFieldForm'].length) {
      this.beneFicaryForm = [];
      this.beneFicaryForm = this.Form1[0]['multiFieldForm'];
      this.Form1[0]['multiFieldForm'].forEach((element) => {
        const temporary = new UntypedFormGroup({});
        temporary.addControl(element.formControlName, new UntypedFormArray([]));
        const test = new UntypedFormGroup({});
        const items = this.documentForm.controls['beneFicaryForm'] as UntypedFormArray;
        items.push(temporary);
      });
      for (let i = 0; i < this.Form1[0]['multiFieldForm'].length; i++) {}
    } else {
      this.beneFicaryForm = [];
    }
    this.t.push(test);
    try {
      this.documentForm.controls.dynamicFieldsForm.controls[0].setValue(dynamicFieldsFormValue);
    } catch (error) {}
    if (this.filterArrayItems.length == 0) {
      this.moveToNextStep.emit();
    }
    this.cd.detectChanges();
  }
}
